import { useEffect, useState } from "react";
import { apiRequest } from "../../Util/api";

/**
 * 사이트 상단 방문자 카운터 — 총방문수 / 어제 / 오늘
 *
 * 탭이 열려 있는 동안에는 방문을 한 번만 기록하고(POST), 그 뒤에는 조회만 합니다(GET).
 * 같은 방문자를 하루 1회로 세는 실제 판정은 서버에서 합니다.
 * 집계 API 가 실패하면 헤더가 깨져 보이지 않도록 아무것도 그리지 않습니다.
 */
const STORAGE_KEY = 'wp_visit_logged';

const todayKey = () => new Date().toLocaleDateString('sv-SE');   // YYYY-MM-DD

const VisitCounter = () => {
    const [stats, setStats] = useState(null);

    useEffect(() => {
        const controller = new AbortController();

        // sessionStorage 를 못 쓰는 브라우저(사생활 보호 모드 등)에서도 동작해야 합니다.
        let alreadyLogged = false;
        try {
            alreadyLogged = window.sessionStorage.getItem(STORAGE_KEY) === todayKey();
        } catch (_) { /* 무시하고 기록 시도 */ }

        const method = alreadyLogged ? "GET" : "POST";

        apiRequest("/pension/visit", method, null, { signal: controller.signal })
            .then((res) => {
                if (!res?.success) return;
                setStats({ total: res.total, yesterday: res.yesterday, today: res.today });
                if (method === "POST") {
                    try { window.sessionStorage.setItem(STORAGE_KEY, todayKey()); } catch (_) { }
                }
            })
            .catch(() => { /* 방문자 수는 부가 정보라 실패해도 화면에는 알리지 않습니다. */ });

        return () => controller.abort();
    }, []);

    if (!stats) return null;

    const format = (n) => Number(n || 0).toLocaleString('ko-KR');

    return (
        <div className="visit-counter" aria-label="방문자 수">
            <span className="visit-counter-total">
                방문수 <strong>{format(stats.total)}</strong>
            </span>
            <span className="visit-counter-sub">
                <span>어제 : <strong>{format(stats.yesterday)}</strong></span>
                <span>오늘 : <strong>{format(stats.today)}</strong></span>
            </span>
        </div>
    );
};

export default VisitCounter;